import React, { useState } from "react";
import HeroSection from "../../components/HeroSection";
import DownloadAppSection from "../../components/DownloadAppSection";
import OtpPopup from "../../components/OTPPopUp";

function Home() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleOtpSubmit = (otp) => {
    console.log("Entered OTP:", otp);
    setIsPopupOpen(false); // Close the popup after submission
  };
  
  return (
    <>
      <HeroSection setOpenOTP={() => setIsPopupOpen(true)} />
      <DownloadAppSection />

      <OtpPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        onSubmit={handleOtpSubmit}
      />
    </>
  );
}

export default Home;
